// The Czech word for the count: 1 fotografie, 2–4 fotografie, 0 or 5 and more fotografií.
export function plural(count: number, one: string, few: string, many: string): string {
    if (count === 1) {
        return one;
    }

    return count >= 2 && count <= 4 ? few : many;
}

export const SUPPORTED_IMAGE_TYPES = ['image/jpeg', 'image/gif', 'image/png', 'image/webp'];

export const PDF_TYPE = 'application/pdf';

/**
 * Splits the dropped or picked files to those that can be uploaded and the names of the others
 */
export function splitSupportedFiles(
    files: File[],
    supportedTypes: string[] = SUPPORTED_IMAGE_TYPES,
): {supported: File[]; rejectedNames: string[]} {
    return {
        supported: files.filter(file => supportedTypes.includes(file.type)),
        rejectedNames: files.filter(file => ! supportedTypes.includes(file.type)).map(file => file.name),
    };
}
